import styled from "styled-components";

const Wrapper = styled.div`
  padding: 4px 8px;
  box-sizing: border-box;
  position: relative;
  margin: 0 auto;
  min-height: 32px;
  color: rgb(102, 102, 102);
`;

export default Wrapper;
